<template>

  <main>
    <section>
      <div class="o-wrapper">
        <div class="c-404">
          <span>4</span>
          <div class="u-4/10@tablet">
            <Shape :img="$globals.general.errorPage.image" :imgOverlay="false" :bg="true" :id="Math.random().toString(36).substring(7)" />
          </div>
          <span>4</span>
        </div>

        <div class="u-7/10@tablet u-push-2/10@tablet u-margin-bottom-large u-margin-bottom-huge@tablet">
          <h3>{{ $globals.general.errorPage.title }}</h3>
          <Button v-if="$globals.general.errorPage.button" class="u-margin-top" :content="$globals.general.errorPage.button" />
        </div>
      </div>
    </section>
  </main>

</template>

<script>
import anime from 'animejs'
import Shape from '@/components/Shape'
import Button from '@/components/Button'

export default {
  name: 'Not Found',

  mounted () {
    anime({
      targets: '.c-bg-anim',
      duration: 800,
      translateX: '110%',
      rotate: -20,
      easing: 'easeInQuad'
    })
  },

  components: {
    Shape,
    Button
  }
}
</script>
